export enum CalendarInterval {
	WEEK,
	MONTH,
	TRIMESTER,
	YEAR,
	NONE
}
